"use client";
import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { FiSun, FiMoon, FiMonitor } from "react-icons/fi";

const OPTIONS = [
    { id: "light", label: "Hell", Icon: FiSun },
    { id: "dark", label: "Dunkel", Icon: FiMoon },
    { id: "system", label: "System", Icon: FiMonitor },
] as const;

// Umschalter Hell / Dunkel / System (System = folgt der Einstellung des Geräts)
const ThemeToggle = ({ withLabels = false }: { withLabels?: boolean }) => {
    const { theme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    // Erst nach dem Laden im Browser ist bekannt, welches Theme aktiv ist
    useEffect(() => setMounted(true), []);

    return (
        <div
            role="radiogroup"
            aria-label="Darstellung"
            className={`flex gap-1 rounded-[10px] border border-ao-line-strong p-1 ${withLabels ? "w-full" : ""}`}
        >
            {OPTIONS.map(({ id, label, Icon }) => {
                const active = mounted && theme === id;
                return (
                    <button
                        key={id}
                        type="button"
                        role="radio"
                        aria-checked={active}
                        aria-label={label}
                        title={label}
                        onClick={() => setTheme(id)}
                        className={`flex h-9 items-center justify-center gap-2 rounded-[7px] transition-colors ${
                            withLabels ? "flex-1 px-3 text-sm font-semibold" : "w-9"
                        } ${active ? "bg-ao-accent text-ao-on-accent" : "text-ao-muted hover:text-ao-fg"}`}
                    >
                        <Icon className="text-base" />
                        {withLabels && label}
                    </button>
                );
            })}
        </div>
    );
};

export default ThemeToggle;
